import React from 'react'

export default function NCC() {
    return (
        <div>NCC</div>
    )
}
